import React, { useState } from 'react';
import axios from 'axios';
import './EtisalatLanding.css';

const EtisalatLanding = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [language, setLanguage] = useState('fa'); // Persian as default
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  // Translations
  const translations = {
    fa: {
      welcome: 'به اتصالات خوش آمدید',
      tagline: 'آینده ارتباطات را تجربه کنید',
      subscribeTitle: 'برای دریافت به‌روزرسانی‌ها عضو شوید',
      phonePlaceholder: 'شماره تلفن',
      subscribeButton: 'عضویت',
      successTitle: 'با تشکر از عضویت شما!',
      successMessage: 'به زودی با شما تماس خواهیم گرفت.',
      errorEmpty: 'لطفا شماره تلفن خود را وارد کنید',
      errorInvalid: 'لطفا یک شماره تلفن معتبر وارد کنید',
      errorApi: 'خطا در ارتباط با سرور. لطفا مجددا تلاش کنید.',
      copyright: '© 2023 اتصالات. تمامی حقوق محفوظ است.',
      switchLanguage: 'English'
    },
    en: {
      welcome: 'Welcome to Etisalat',
      tagline: 'Experience the future of telecommunications',
      subscribeTitle: 'Subscribe for updates',
      phonePlaceholder: 'Phone number',
      subscribeButton: 'Subscribe',
      successTitle: 'Thank you for subscribing!',
      successMessage: 'We will contact you shortly.',
      errorEmpty: 'Please enter your phone number',
      errorInvalid: 'Please enter a valid phone number',
      errorApi: 'Error connecting to server. Please try again.',
      copyright: '© 2023 Etisalat. All rights reserved.',
      switchLanguage: 'فارسی'
    }
  };

  const t = translations[language];

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    setPhoneNumber(value);
    setError('');
  };

 const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!phoneNumber) {
      setError(t.errorEmpty);
      return;
    }
    
    if (phoneNumber.length < 10) {
      setError(t.errorInvalid);
      return;
    }
    
    setIsSubmitting(true);
    setError('');
    
    try {
      // Prepare the request data
      const requestData = {
        phone: phoneNumber,
        // Add any additional required fields here
      };

      // Make the API call
      const response = await axios.post(
        'https://vas1.gtmultiverse.com/api/PlayIt/etisalat-af-d/subscribe',
        requestData,
        {
          headers: {
            'Content-Type': 'application/json',
            // Add any required headers here
          }
        }
      );

      // Handle response
      if (response.data && response.data.success) {
        setIsSuccess(true);
        setPhoneNumber('');
      } else {
        // Display the error message from the API response if available
        const errorMessage = (response.data && response.data.message) || t.errorApi;
        setError(errorMessage);
      }
    } catch (err) {
      console.error('API Error:', err);
      // If we have a response with an error message, use it
      const errorMessage = (err.response && err.response.data && err.response.data.message) || t.errorApi;
      setError(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };


  const toggleLanguage = () => {
    setLanguage(language === 'fa' ? 'en' : 'fa');
  };

  return (
    <div className={`landing-container ${language === 'fa' ? 'rtl' : 'ltr'}`}>
      {/* Header with logo and language toggle */}
      <header className="landing-header">
        <div className="logo-container">
          <img 
            src="etisalat-logo.svg" 
            alt="Etisalat Logo"
            className="logo"
          />
        </div>
        <button 
          onClick={toggleLanguage}
          className="language-toggle"
        >
          {t.switchLanguage}
        </button>
      </header>

      {/* Main content */}
      <main className="landing-content">
        <div className="brand-message">
          <h1 className="headline">
            {t.welcome}
          </h1>
          <p className="subhead">
            {t.tagline}
          </p>
        </div>

        {/* Subscription form */}
        <div className="subscription-form">
          {isSuccess ? (
            <div className="success-message">
              <h2>{t.successTitle}</h2>
              <p>{t.successMessage}</p>
            </div>
          ) : (
            <>
              <h2>{t.subscribeTitle}</h2>
              <form onSubmit={handleSubmit}>
                <div className={`input-group ltr-input-group`}>
                  <input
                    type="tel"
                    value={phoneNumber}
                    onChange={handlePhoneChange}
                    placeholder={t.phonePlaceholder}
                    className="phone-input"
                    dir={language === 'fa' ? 'rtl' : 'ltr'}
                  />
                  <button 
                    type="submit" 
                    className="subscribe-button"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <span className="spinner"></span>
                    ) : (
                      t.subscribeButton
                    )}
                  </button>
                </div>
                {error && <p className="error-message">{error}</p>}
              </form>
            </>
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="landing-footer">
        <p>{t.copyright}</p>
      </footer>
    </div>
  );
};

export default EtisalatLanding;